
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TreeFilterRangeRow from "./TreeFilterRangeRow.vue";

export interface TreeFiltersModel {
 search: string;
  date_joined_from: string;
  date_joined_to: string;
  users_count_first_line_min: string | null;
  users_count_first_line_max: string | null;
  level_min: string | null;
  level_max: string | null;
}

const defaultFilters = (): TreeFiltersModel => ({
  search: "",
      date_joined_from: "",
      date_joined_to: "",
      users_count_first_line_min: null,
      users_count_first_line_max: null,
      level_min: null,
      level_max: null,
});

@Component({
  components: { TreeFilterRangeRow },
})
export default class TeamTreeFilter extends Vue {
  /** Controls visibility. Use .sync modifier: :visible.sync="showFilters" */
  @Prop({ type: Boolean, default: false })
  readonly visible!: boolean;

  /** Initial filter values passed from parent */
  @Prop({ type: Object, default: () => ({}) })
  readonly filters!: Partial<TreeFiltersModel>;

  localFilters: TreeFiltersModel = { ...defaultFilters(), ...this.filters };

  @Watch("filters", { deep: true })
  onFiltersChanged(val: Partial<TreeFiltersModel>): void {
    this.localFilters = { ...defaultFilters(), ...val };
  }
  
  handleChangeFilters(): void {
   const normalized: TreeFiltersModel = {
    ...this.localFilters,
    users_count_first_line_min: this.localFilters.users_count_first_line_min || null,
    users_count_first_line_max: this.localFilters.users_count_first_line_max || null,
    level_min: this.localFilters.level_min || null,
    level_max: this.localFilters.level_max || null,
  };
    this.$emit("change", normalized);
  }
  handleResetFilters(): void {
    this.$emit("reset")
  }
}
